import React, { useEffect, useState } from "react";
import { Card, Row, Col, Spinner, Badge, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { var_api } from "../../../constant";

const SubscriptionPage = () => {
  const warehouseId = localStorage.getItem("warehouse_id");

  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [payingId, setPayingId] = useState(null);

  // 🔹 Fetch subscriptions
  const fetchSubscriptions = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${var_api}subscription/getbywarehouse/${warehouseId}`);

      if (res.data) {
        setSubscriptions(res.data);
      } else {
        setSubscriptions([]);
      }
    } catch (error) {
      toast.error("Failed to load subscriptions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscriptions();
  }, []);

  // 🔹 Pay Now
  const handlePayNow = async (sub) => {
    try {
      setPayingId(sub.id);

      // 1️⃣ Create Razorpay order
      const orderRes = await axios.post(
        `${var_api}subscription/create-razorpay-order`,
        {
          warehouse_id: warehouseId,
          amount: sub.amount,
        }
      );

      const { order_id, amount, key } = orderRes.data;

      // 2️⃣ Open Razorpay
      const options = {
        key,
        amount,
        currency: "INR",
        name: "Veemart Subscription",
        description: `Subscription - ${sub.bill_date}`,
        order_id,
        handler: async function (response) {
          try {
            await axios.post(`${var_api}subscription/verify-payment`, {
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,
              warehouse_id: warehouseId,
              subscription_id: sub.id,
            });

            toast.success("Subscription paid successfully 🎉");
            fetchSubscriptions();
          } catch (err) {
            toast.error("Payment verification failed");
          }
        },
        theme: { color: "#0d6efd" },
      };

      new window.Razorpay(options).open();

    } catch (err) {
      console.error(err);
      toast.error("Payment failed");
    } finally {
      setPayingId(null);
    }
  };

  return (
    <>
      {/* 🔹 Full Page Loader */}
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255,255,255,0.9)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <div className="text-center">
            <Spinner animation="border" variant="primary" />
            <div className="mt-2 fw-bold">Loading Subscriptions...</div>
          </div>
        </div>
      )}

      <Card className="shadow-sm">
        <Card.Body>
          <Row className="mb-3">
            <Col>
              <h4>
                <i className="bi bi-receipt me-2"></i> Subscription Management
              </h4>
              <small className="text-muted">
                View and manage your monthly subscriptions
              </small>
            </Col>
          </Row>

          <div className="table-responsive">
            <table className="table ">
              <thead >
                <tr>
                  <th>#</th>
                  <th>Bill Month</th>
                  <th>Amount (₹)</th>
                  <th>Status</th>
                  <th>Paid Date</th>
                  <th>Transaction Id</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {subscriptions.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center text-muted py-4">
                      No subscription records found
                    </td>
                  </tr>
                ) : (
                  subscriptions.map((sub, idx) => (
                    <tr key={sub.id}>
                      <td>{idx + 1}</td>
                      <td>{sub.bill_date}</td>
                      <td>
                        <strong>
                          ₹ {Number(sub.amount).toLocaleString("en-IN")}
                        </strong>
                      </td>
                      <td>
                        {sub.is_paid == 0 ? (
                          <Badge bg="danger">UNPAID</Badge>
                        ) : (
                          <Badge bg="success">PAID</Badge>
                        )}
                      </td>
                      <td>
                        {sub.paid_datetime
                          ? new Date(sub.paid_datetime).toLocaleString()
                          : "-"}
                      </td>

                       <td>
                        {sub.razor_transaction_id}
                      </td>
                      <td>
                        {sub.is_paid == 0 ? (
                          <Button
                            size="sm"
                            variant="primary"
                            onClick={() => handlePayNow(sub)}
                            disabled={payingId === sub.id}
                          >
                            {payingId === sub.id ? (
                              <Spinner size="sm" />
                            ) : (
                              "Pay Now"
                            )}
                          </Button>
                        ) : (
                          <span className="text-muted">—</span>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </Card.Body>
      </Card>

      <ToastContainer position="top-right" />
    </>
  );
};

export default SubscriptionPage;
